var DialogAnimations = /*#__PURE__*/ function(DialogAnimations) {
    DialogAnimations["FadeIn"] = "fade-in";
    DialogAnimations["FadeInFromBottom"] = "fade-in-from-bottom";
    DialogAnimations["FadeInFromLeft"] = "fade-in-from-left";
    DialogAnimations["FadeInFromRight"] = "fade-in-from-right";
    DialogAnimations["FadeInFromTop"] = "fade-in-from-top";
    return DialogAnimations;
}({});
var DialogSizes = /*#__PURE__*/ function(DialogSizes) {
    DialogSizes["Auto"] = "auto";
    DialogSizes["Fullscreen"] = "fullscreen";
    DialogSizes["Large"] = "large";
    DialogSizes["Medium"] = "medium";
    DialogSizes["Small"] = "small";
    DialogSizes["Unlimited"] = "unlimited";
    DialogSizes["Xlarge"] = "xlarge";
    DialogSizes["Xsmall"] = "xsmall";
    DialogSizes["Xxlarge"] = "xxlarge";
    DialogSizes["Xxsmall"] = "xxsmall";
    return DialogSizes;
}({});
var DialogTypes = /*#__PURE__*/ function(DialogTypes) {
    DialogTypes["Drawer"] = "drawer";
    DialogTypes["Modal"] = "modal";
    return DialogTypes;
}({});
var DrawerAnimations = /*#__PURE__*/ function(DrawerAnimations) {
    DrawerAnimations["FadeInFromLeft"] = "fade-in-from-left";
    DrawerAnimations["FadeInFromRight"] = "fade-in-from-right";
    return DrawerAnimations;
}({});

export { DialogAnimations, DialogSizes, DialogTypes, DrawerAnimations };
//# sourceMappingURL=dialog.js.map
